import { __awaiter, __generator } from "tslib";
import debounce from 'lodash.debounce';
var AdiCategorySearchService = /** @class */ (function () {
    function AdiCategorySearchService(apiClient, onLoad) {
        this.apiClient = apiClient;
        this.onLoad = onLoad;
        this.suggest = debounce(this.search, 200);
    }
    AdiCategorySearchService.prototype.search = function (term) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.suggest(term)];
                    case 1:
                        data = _a.sent();
                        this.onLoad(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    return AdiCategorySearchService;
}());
export { AdiCategorySearchService };
//# sourceMappingURL=AdiCategorySearchService.js.map